<template>
  <div
    v-for="n in 4"
    :key="n"
    class="junip-product-summary-star junip-star-filled"
  >
    <svg
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
    >
      <title>Filled star</title>
      <path
        d="m3.2 16.0001081c-.1687782 0-.33328968-.0531313-.47-.1521081-.24051968-.174488-.36451194-.4679107-.322-.762l.743-5.203-2.917-2.917c-.21191095-.21196521-.28756133-.52460199-.196-.81.09130759-.2851682.3345701-.49522345.63-.544l4.398-.734 2.218-4.435c.13744692-.27145241.41573373-.4426761.72-.443.3045618.00166772.58175678.1761261.715.45l2.123 4.362 4.498.801c.2933158.05211246.5333796.26289081.623.547.0898959.28455453.0135125.59548872-.198.806l-2.917 2.917.744 5.203c.042199.2957461-.0839008.5903645-.327.764-.2421349.1739598-.5609835.1986349-.827.064l-4.382-2.22-4.502 2.223c-.10996656.0547452-.23116004.0831081-.354.0831081z"
        fill="var(--junipStarColor)"
      />
    </svg>
  </div>
  <div
    class="junip-product-summary-star junip-star-filled"
  >
    <svg
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
    >
      <title>1/2 star</title>
      <path
        d="M 3.2 16 C 3.031 16 2.867 15.947 2.73 15.848 C 2.489 15.674 2.365 15.38 2.408 15.086 L 3.151 9.883 L 0.234 6.966 C 0.022 6.754 -0.054 6.441 0.038 6.156 C 0.129 5.871 0.373 5.661 0.668 5.612 L 5.066 4.878 L 7.284 0.443 C 7.421 0.172 7.7 0 8.004 0 C 8.309 0.002 8.586 0.176 8.719 0.45 L 10.842 4.812 L 15.34 5.613 C 15.633 5.665 15.873 5.876 15.963 6.16 C 16.053 6.445 15.977 6.755 15.765 6.966 L 12.848 9.883 L 13.592 15.086 C 13.634 15.382 13.508 15.676 13.265 15.85 C 13.023 16.024 12.704 16.049 12.438 15.914 L 8.056 13.694 L 3.554 15.917 C 3.444 15.972 3.323 16 3.2 16 Z M 8 6 L 8 11.5 L 11.286 13.088 L 10.726 9.176 L 12.724 7.179 L 8 6 Z"
        fill="var(--junipStarColor)"
      />
    </svg>
  </div>
</template>
